var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"print-view"},[_c('div',{staticClass:"flex justify-center"},[(_vm.file)?_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":_vm.file}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }